import Partie from "@/firebase/tirage2/Partie.js"
import Joueur from "@/firebase/tirage2/Joueur.js"
import Equipe from "@/firebase/tirage2/Equipe.js"
import firebase_api from "@/firebase/firebase_api"
import TerrainC from "./Terrain"
export default class Tirage {
    getJsonWithOutError = false;
    nbParties = null;
    nbJoueurs = null;
    options = null;
    parties = [];
    joueurs = [];
    NBreinit = 0;
    error = false;
    partiesJSON = null;
    joueursJSON = null;
    numeroRestantJoueurs = [];
    nbError = 1000;
    nbJoueursParEquipeOption = null;
    custom = false;
    constructor(options, partiesJSON) {
        this.options = options;
        
        this.custom = this.options.nbJoueursParEquipe==-1;
        this.nbParties = options.nbParties;
        this.nbJoueurs = options.nbJoueurs;
        if (typeof(partiesJSON) != "undefined") {
            
            this.initDatasFromPartiesJSON(options, partiesJSON);
            this.nbJoueurs = this.joueurs.length;
            this.nbParties = this.parties.length;
        }
        if (options.mode == "FORME") {
           
         // this.nbJoueurs = Math.floor(this.options.joueurs.length / this.options.nbJoueursParEquipe);
            this.nbJoueurs = 0;
            this.options.joueurs.forEach(joueur=>{
                if (joueur.meneur)
                    this.nbJoueurs++;
            })
        
            this.nbJoueursParEquipeOption = this.options.nbJoueursParEquipe;
            this.options.nbJoueursParEquipe = 1;
        }
    }
   
    checkError () {
        this.nbError = 0;
        this.parties.forEach(partie=>{
            this.nbError += partie.checkError();
        })
        return this.nbError;
    }
    joueurIsInJoueurs(value) {
        var find = false;
        this.joueurs.forEach(joueur=>{
            if (typeof(joueur) != "undefined") {
                find = joueur.numero == value;
            }
        })
        return find;
    }
    equipeGagnant(equipe, key) {
        var vsEquipe = (key == 'contre') ? 'joueurs' : 'contre';
        return equipe.score[key] > equipe.score[vsEquipe];
    }
    initDatasFromPartiesJSON (options, partiesJSON) {
        this.parties = [];
        this.joueurs = [];
        
      
        partiesJSON.forEach((partie, indexPartie)=>{
           /* if (!partie.complementaire) {*/
              
                partie.equipes.forEach(equipe=>{
                    for (var key in equipe) {
                        if (key == "contre" || key=="joueurs") {
                            for (var joueurLoop in equipe[key]) {
                                if (equipe[key][joueurLoop] != null) {
                                    
                                    var numero = equipe[key][joueurLoop].numero;
                                    if (typeof(this.joueurs[numero]) == "undefined") {
                                   // if (!this.joueurIsInJoueurs(numero)) {
                                        var joueur = new Joueur (options, numero);
                                        this.joueurs[numero] = joueur;
                                        // TODO
                                        // ouais mais là ca va pas du tour
                                        // quand on retinialise il faut remettre les erreurs
                                        // et surtout les parties des joueurs
                                        // pour que le traitement d'erreur fonctionne 
                                        // 
                                        if (typeof(equipe[key][joueurLoop].parties) == "undefined")
                                            this.joueurs[numero].parties = [];
                                        else
                                            this.joueurs[numero].parties = equipe[key][joueurLoop].parties;
                                        this.joueurs[numero].error = equipe[key][joueurLoop].error;
                                        this.joueurs[numero].errorDetail = equipe[key][joueurLoop].errorDetail;

                                    }
                                   
                                    if (equipe.state == "FINISH") {
                                        var gagne = this.equipeGagnant(equipe, key);
                                        if (gagne)
                                            this.joueurs[numero].gagnes++;
                                        
                                        if ((equipe.score[key] != null && equipe.score[key] != '') || equipe.score[key]=='0')
                                            this.joueurs[numero].gagnesByPartie[indexPartie] = this.joueurs[numero].gagnes;
                                    }
                                }
                                
                            }
                        }
                       
                    }
                })
            /*}*/
           
        })
       
        partiesJSON.forEach((partie, indexPartie)=>{
         /*   if (!partie.complementaire) {*/
                this.parties[indexPartie] = new Partie(indexPartie, this.options, [], this.joueurs);
                this.parties[indexPartie].state = partie.state;
                partie.equipes.forEach(equipe=>{
                    var equipeInst = new Equipe (indexPartie, options, [], this.joueurs);
                    var joueurNotNull = false;

                    if (typeof(equipe.terrain)!="undefined")
                        equipeInst.terrain = equipe.terrain;

                    if (typeof(equipe.exists)!="undefined")
                        equipeInst.exists = equipe.exists;
                    else
                        equipeInst.exists = null;

                    if (typeof(equipe.triplette)!="undefined")
                        equipeInst.triplette = equipe.triplette;
                    else
                        equipeInst.triplette = null;

                    for (var key in equipe) {
                        if (key == "contre" || key=="joueurs") {
                            for (var joueurLoop in equipe[key]) {
                                if (equipe[key][joueurLoop] != null) {
                                    equipeInst.dataJoueurs[key][joueurLoop] = 
                                        this.joueurs[equipe[key][joueurLoop].numero];
                                    if (key == "contre") 
                                        joueurNotNull = true;
                                }
                            }
                            equipeInst.score = JSON.parse(JSON.stringify(equipe.score));
                            equipeInst.ggGagnes = equipe.ggGagnes;
                        }
                    }
                    /*if (!this.options.allEquipePlay && !joueurNotNull && !this.options.addPartie && !this.options.GG) {
                        equipeInst.score.joueurs = this.options.ifNotFound.win;
                        equipeInst.score.contre = this.options.ifNotFound.lose;
                    }*/
                  
                    equipeInst.reinitJoueurs(this.joueurs);
                    this.parties[indexPartie].equipes.push(equipeInst);
                })
            /*   }*/
        })
       
    }
    saveJSON() {
        
        
        var partiesJSON = [];
        var joueurJSON = [];
        this.joueurs.forEach((joueur, index)=>{
                joueurJSON[index] = joueur.getJSON();
        })
        this.joueursJSON = joueurJSON;
        if (!this.getJsonWithOutError) {
            this.parties.forEach((partie, index)=>{
                partiesJSON[index] = {
                    equipes: [],
                    state: "WAITING",
                    error: partie.error,
                    nbError : this.nbError,
                    nbTirage : this.NBreinit,
                    complementaire: partie.complementaire,
                    joueurs: joueurJSON
                }
                partie.equipes.forEach(equipe=>{
                    partiesJSON[index].equipes.push(equipe.getJSON());
                })
            })
           
            this.partiesJSON = JSON.parse(JSON.stringify(partiesJSON));
            if (typeof(this.options.zones)!="undefined")
            if (Object.keys(this.options.zones).length>0) {
                var terrain  = new TerrainC();
                terrain.init(this.options, this.partiesJSON)
            }
        }
    }
    exec (startIndexPartie) {
        // On initialise un tableau pour pouvoir gérer les randoms 
        //this.joueurs = [];
        var pointError = 0;
        
        
        if (typeof(startIndexPartie) == "undefined") {
            // Alors on reinitialise que la partie en fonction de l'index Partie
            startIndexPartie = 0;
        }
        
        for (var indexPartie = startIndexPartie; indexPartie < this.nbParties; indexPartie++) {
            //console.log(JSON.parse(JSON.stringify(this.options)));
            if (this.custom) {
                this.options.nbJoueursParEquipe = this.options.tabNbJoueursParEquipe[indexPartie];
                this.options.allEquipePlay = this.options.nbJoueursParEquipe != 1;
            } 
           // console.log(JSON.parse(JSON.stringify(this.options)));
            var numeroRestantJoueurs = this.numeroRestantJoueurs.slice();
           
            var partie = new Partie(indexPartie, this.options, numeroRestantJoueurs, this.joueurs);
            partie.reinit = 0;
            
            partie.init();
            
            pointError += partie.nbError;
            this.parties[indexPartie] = partie;
        }
      

        return pointError;
    }
    init (startIndexPartie) {
        
        var tantQue = true;
        var winNbError = Number.MAX_VALUE;
        var error = false;
        this.NBreinit = 0;
        var jsonSave = null;
        var save = null;
        var saveNbError = null;
        
        if (typeof(startIndexPartie) == "undefined" || startIndexPartie == 0) {
            // Alors on reinitialise que la partie en fonction de l'index Partie
            startIndexPartie = 0;
            
            this.joueurs = [];
            for (var indexJoueur = 0;indexJoueur < this.nbJoueurs;indexJoueur++) {
                this.numeroRestantJoueurs[indexJoueur] = indexJoueur;
                if (typeof(this.joueurs[indexJoueur]) == "undefined")
                    this.joueurs[indexJoueur] = new Joueur (this.options, indexJoueur);
            }
        }
      
        while (tantQue) {
            for (var indexJoueur = 0;indexJoueur < this.joueurs.length;indexJoueur++) {
                this.numeroRestantJoueurs[indexJoueur] = indexJoueur;
                this.joueurs[indexJoueur].parties.forEach((partie, indexPartie)=>{
                    if (indexPartie>=startIndexPartie) {
                        this.joueurs[indexJoueur].parties[indexPartie] = {
                            joueurs: [],
                            contre: []
                        };
                        
                    }
                })
                this.joueurs[indexJoueur].amis = [];
                this.joueurs[indexJoueur].contre = [];
                for (var indexError in this.joueurs[indexJoueur].errorDetail) {
                    if (parseInt(indexError)>=startIndexPartie) {
                        this.joueurs[indexJoueur].errorDetail[indexError] = [];
                        this.joueurs[indexJoueur].error = 0;
                    }
                }
            }
           
            if (this.NBreinit > 5000) {
                tantQue = false;
            }   
            else {
                this.NBreinit ++ ;
                 
               
                this.exec (startIndexPartie);
                this.reinitEquipes();
                this.checkError();
                var tantQue = this.nbError  != 0;   
                if (this.nbError == 0) {
                    error = false;
                    this.saveJSON();
                }
                else
                    error = true;

                if (this.nbError < winNbError) {
                    this.saveJSON();
                    saveNbError = this.nbError;
                    winNbError = this.nbError;
                }            
            }
        }

        if (saveNbError!=null) {
            this.nbError = saveNbError;
        }
        
        this.remplieLesCooequipiers();
        
        this.addPartieComplementaire();

        if (startIndexPartie==0 && !this.options.addPartie)
            this.saveModele(this.nbError);
          
        return error;
    }
    reinitEquipes() {
        this.parties.forEach(partie=>{
            partie.reinitEquipes();
        })
    }
    saveModele(error) {
        var docModeleId = this.options.nbJoueursParEquipe +"_"+this.nbParties+"_";
        if (this.options.addPartie)
            docModeleId += "add";
        if (!this.options.allEquipePlay)
            docModeleId += "notAll";
        if (this.options.mode == 'ALEA' && !this.options.GG && !this.custom) { 
            firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId).get().then(doc=>{
                if (doc.exists) {
                    var listNbJoueurs = doc.data().listJoueurs;
                    var listItem = listNbJoueurs["J"+this.nbJoueurs];
                    
                    if (typeof(listItem) == "undefined") {
                        listNbJoueurs["J"+this.nbJoueurs] = this.nbError;
                        firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId).update({
                            listJoueurs : listNbJoueurs
                        })
                    }
                    if (listItem > this.nbError || typeof(listItem)=="undefined") {
                        firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId)
                            .collection("modeles").doc("M"+this.nbJoueurs).set({
                                json: this.partiesJSON
                            }).then(()=>{
                                listNbJoueurs["J"+this.nbJoueurs] = this.nbError;
                                doc.ref.update({
                                    listJoueurs : listNbJoueurs
                                })
                            })
                    }
                
                }
                else {
                    var listNbJoueurs = {};
                    listNbJoueurs["J"+this.nbJoueurs] = this.nbError;
                    firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId).set({
                        listJoueurs : listNbJoueurs
                    })
                    .then(()=>{
                        firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId)
                            .collection("modeles").doc("M"+this.nbJoueurs).set({
                                json: this.partiesJSON
                            })
                    })
                } 

            })
        }
    }
    async findModeleJSON (nbError) {
        
        var docModeleId = this.options.nbJoueursParEquipe +"_"+this.nbParties+"_";
        var findModele = false;
        if (this.options.mode == 'ALEA' && !this.options.GG && !this.custom) { 
           
            var doc = await firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId).get();
           
            if (doc.exists) {
                var listNbJoueurs = doc.data().listJoueurs;
                var listItem = listNbJoueurs["J"+this.nbJoueurs];
                if (doc.exists) {
                 
                    if (listItem < nbError) {
                      
                        try {
                            var dataElement = await firebase_api.api.getDb().collection("erreur_tirage").doc(docModeleId)
                                .collection("modeles").doc("M"+this.nbJoueurs).get();
                           
                            if (dataElement.exists) {
                                var jsonData = dataElement.data().json;
                                
                                this.updateNumero(jsonData);
                                findModele = true;
                            
                                return {
                                    jsonData: jsonData,
                                    find: true
                                }
                            }
                        }
                        catch(err) {
                            console.log("ERREUR")
                        }
                    }
                }
            } 
        }      
        if (!findModele) {
            return {
                jsonData: null,
                find: false
            }
        }
    }
    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }
    updateNumero(jsonPartie) {
        var numeroRestant = [];
        var numeroARemplacer = [];
        jsonPartie.forEach((partie,indexPartie)=>{
            partie.equipes.forEach(equipe=>{
                for (var key in equipe) {
                    if (key == "joueurs" || key=="contre") {
                        for (var joueur in equipe[key]) {
                            if (equipe[key][joueur]!=null) {
                                numeroRestant[equipe[key][joueur].numero] = equipe[key][joueur].numero;
                            }
                        }
                    }
                }
            })
        })
        var indexNumero = 0;
        while (numeroRestant.length>0) {
            var indexRandom = this.getRandomInt(numeroRestant.length);
            numeroARemplacer[indexNumero] = numeroRestant[indexRandom];
            indexNumero ++;
            numeroRestant.splice(indexRandom, 1);
        }
        jsonPartie.forEach((partie,indexPartie)=>{
            partie.equipes.forEach(equipe=>{
                for (var key in equipe) {
                    if (key == "joueurs" || key=="contre") {
                        for (var joueur in equipe[key]) {
                            if (equipe[key][joueur]!=null) {
                                equipe[key][joueur].numero = numeroARemplacer[equipe[key][joueur].numero];
                            }
                        }
                    }
                }
            })
        })
    }
    addPartie() {
        this.nbParties ++;
        var indexJoueur = 0;
        
        for (var numeroJoueur = 0;numeroJoueur < this.nbJoueurs;numeroJoueur++) {
            if (typeof(this.options.abandonJoueurs)!=="undefined") {
                if (typeof(this.options.abandonJoueurs[numeroJoueur])==="undefined") {
                        this.numeroRestantJoueurs[indexJoueur] = numeroJoueur;
                        indexJoueur++;
                }
            }
            else {
                this.numeroRestantJoueurs[indexJoueur] = numeroJoueur;
                indexJoueur++;
            }
           
        }
       

        var newpartie = new Partie(this.parties.length, this.options, this.numeroRestantJoueurs, this.joueurs);
        
        newpartie.init();
        
        if (typeof(this.options.abandonJoueurs)!="undefined") {
            for(var numeroJoueur in this.options.abandonJoueurs) {
                var equipeAdd = new Equipe (this.parties.length, this.options, [], this.joueurs);
                var joueur = this.joueurs[numeroJoueur];
                equipeAdd.dataJoueurs.joueurs.J1 = joueur;
                equipeAdd.dataJoueurs.contre.J1 = null;
                equipeAdd.score.joueurs = 7;
                equipeAdd.score.contre = 13;
                equipeAdd.reinitJoueurs(this.joueurs);
                newpartie.equipes.push(equipeAdd);
            }
        }
        newpartie.checkError();
        this.parties.push(newpartie);
        this.saveJSON();
        
        this.remplieLesCooequipiers();
        return this.nbParties - 1;
    }
    
    reinit(startIndexPartie) {
       
        /* En fait l'idée est de simuler autant de partie qu'il y a de joueurs qui ont gagnés
        0 parties, 1 parties 2 partes .... */
         var pointError = 0;
         for (var indexJoueur = 0;indexJoueur < this.joueurs.length;indexJoueur++) {
            if (typeof(this.joueurs[indexJoueur]) !="undefined") {
                this.joueurs[indexJoueur].parties.forEach((partie, indexPartie)=>{
                    if (indexPartie>=startIndexPartie) {
                        this.joueurs[indexJoueur].parties[indexPartie] = {
                            joueurs: [],
                            contre: []
                        };
                        
                    }
                })
                this.joueurs[indexJoueur].amis = [];
                this.joueurs[indexJoueur].contre = [];
                for (var indexError in this.joueurs[indexJoueur].errorDetail) {
                    if (parseInt(indexError)>=startIndexPartie) {
                        this.joueurs[indexJoueur].errorDetail[indexError] = [];
                        this.joueurs[indexJoueur].error = 0;
                    }
                }
            }
        }
        for (var indexPartie = startIndexPartie; indexPartie < this.parties.length ;indexPartie++) {
            
            if (this.custom) {
               
                this.options.nbJoueursParEquipe = this.options.tabNbJoueursParEquipe[indexPartie];
               
            }
            var newpartie = new Partie(indexPartie, this.options, [], this.joueurs);
            var equipeNotReinit = {};
            var partie = this.parties[indexPartie];
            partie.equipes.forEach((equipe, indexEquipe)=>{
                if (this.equipeHasScore(equipe))
                    equipeNotReinit[indexEquipe] = equipe;
            })
            for (var indexEquipe in equipeNotReinit) {
                var equipe = equipeNotReinit[indexEquipe];
                newpartie.equipes[indexEquipe] = equipe;
                newpartie.equipes[indexEquipe].reinitJoueurs(this.joueurs);
            }
            
            var numeroRestantJoueurs = [];
            
            this.joueurs.forEach(joueur=>{
                if (this.options.mode == 'FORME' && typeof(this.options.joueurs[joueur.numero])!="undefined") {
                    if (this.options.joueurs[joueur.numero].meneur) {
                        numeroRestantJoueurs.push(joueur.numero);
                    }
                }
                else
                    numeroRestantJoueurs.push(joueur.numero);
            })
            partie.equipes.forEach((equipe, indexEquipe)=>{
                if (this.equipeHasScore(equipe)) {
                    for (var key in equipe.dataJoueurs)
                        for (var joueur in  equipe.dataJoueurs[key])
                            if (equipe.dataJoueurs[key][joueur]!=null) {
                                var numero = equipe.dataJoueurs[key][joueur].numero;
                                if (this.options.mode == 'FORME' && typeof(this.options.joueurs[numero])!="undefined") {
                                    if (this.options.joueurs[numero].meneur) {
                                        var indexFindNumero = numeroRestantJoueurs.findIndex(elt=>elt === numero);
                                        if (indexFindNumero!=-1)
                                            numeroRestantJoueurs.splice(indexFindNumero, 1);
                                    }
                                        
                                }
                                else {
                                    var indexFindNumero = numeroRestantJoueurs.findIndex(elt=>elt === numero);
                                    if (indexFindNumero!=-1)
                                        numeroRestantJoueurs.splice(indexFindNumero, 1);
                                }
                            }
                }
            })
           
           
            var options = JSON.parse(JSON.stringify(this.options));
            if (options.mode == 'FORME')
                options.nbJoueursParEquipe = 1;
            var partieTempo = new Partie (indexPartie, options, numeroRestantJoueurs, this.joueurs);
            partieTempo.init();
          
            pointError += partieTempo.nbError;
            var indexEquipeNew  = 0;
            
            partieTempo.equipes.forEach(equipe=>{
               
                while (typeof(equipeNotReinit[indexEquipeNew])!="undefined" || equipeNotReinit[indexEquipeNew]!=null)
                    indexEquipeNew++;
             
                newpartie.equipes[indexEquipeNew] = equipe;
                newpartie.equipes[indexEquipeNew].reinitJoueurs(this.joueurs);
                indexEquipeNew++;
            })
            
            
            if (numeroRestantJoueurs.length == 1) {
                var equipeAdd = new Equipe (this.parties.length, this.options, [], this.joueurs);
                var joueur = this.joueurs[numeroRestantJoueurs[0]];
                equipeAdd.dataJoueurs.joueurs.J1 = joueur;
                equipeAdd.dataJoueurs.contre.J1 = null;
                equipeAdd.score.joueurs = this.options.win;
                equipeAdd.score.contre = this.options.lose;
                equipeAdd.ggGagnes = "";
                equipeAdd.reinitJoueurs(this.joueurs);
                newpartie.equipes.push(equipeAdd);
            }
          
            newpartie.checkError();
            
            
            this.parties[indexPartie] = newpartie;
           
        }
        if (this.custom)
            this.options.nbJoueursParEquipe=-1;
        
        this.saveJSON();
        
        this.checkError();
        this.remplieLesCooequipiers();
        this.nbError = pointError;
        return pointError!=0;
    }
    
    addPartieGGByGA() {
        var resultatEquipes = [];
        var classement=[];
       
        this.parties.forEach((partie,indicePartie)=>{
        
            partie.equipes.forEach(equipe=>{
                var numeroAGagne=null;
                var numeroAPedu=null;
                var pointPerdu= 0;
                if (equipe.score.joueurs>equipe.score.contre) {

                    numeroAGagne = equipe.dataJoueurs["joueurs"].J1.numero;
                    
                    if (equipe.dataJoueurs["contre"].J1!=null)
                        numeroAPedu = equipe.dataJoueurs["contre"].J1.numero;
                    pointPerdu = equipe.score.contre;

                }
                else {
                    numeroAGagne = equipe.dataJoueurs["contre"].J1.numero;
                    numeroAPedu = equipe.dataJoueurs["joueurs"].J1.numero;
                    pointPerdu = equipe.score.joueurs
                }
                if (typeof(resultatEquipes[numeroAGagne])=="undefined") {
                    resultatEquipes[numeroAGagne] = {
                        score: 0,
                        ggGagnes: 0,
                        contre:[]
                    }
                }
                if (typeof(resultatEquipes[numeroAPedu])=="undefined" && numeroAPedu!=null) {
                    resultatEquipes[numeroAPedu] = {
                        score: 0,
                        ggGagnes: 0,
                        contre:[]
                    }
                }
                resultatEquipes[numeroAGagne].score += 100 + Math.abs(equipe.score.joueurs - equipe.score.contre);
                resultatEquipes[numeroAGagne].ggGagnes++;
                if (numeroAPedu!=null) {
                    resultatEquipes[numeroAGagne].contre.push(numeroAPedu);
                    resultatEquipes[numeroAPedu].score += pointPerdu;
                    resultatEquipes[numeroAPedu].contre.push(numeroAGagne);
                }
            })
           
        })
       
        for (var numero in resultatEquipes) {
            var equipe = {
                numero: parseInt(numero),
                score: resultatEquipes[numero].score,
                equipe: resultatEquipes[numero]
            }
            classement.push(equipe)
        }
        classement.sort(function(a,b) {
            return b.score - a.score;
        })
        var lastEquipeWin=null;
        
        // le dernier du classement ne joue pas si le nombre de joueurs n'est pas pair ...
        if ((classement.length % 2) != 0) {
            var bool = true;
            var indiceClassement = classement.length-1;
            while (bool) {
                
                if (classement[indiceClassement].equipe.contre.length == this.parties.length) {
                    lastEquipeWin = new Equipe (this.parties.length, this.options, [], this.joueurs);
                    lastEquipeWin.ggGagnes = classement[indiceClassement].equipe.ggGagnes;
                    var joueur = this.joueurs[classement[indiceClassement].numero];
                    lastEquipeWin.dataJoueurs.joueurs.J1 = joueur; 
                    lastEquipeWin.dataJoueurs.contre.J1 = null; 
                    lastEquipeWin.score.joueurs = 13;
                    lastEquipeWin.score.contre = 7;
                }
               
                if (indiceClassement==0)
                    bool = false;
                else if (lastEquipeWin!=null)
                    bool = false;
                else
                    indiceClassement--;
            }
            classement.splice(indiceClassement,1);
        }
        
        var newpartie = new Partie(this.parties.length, this.options, [], []);
        var bigBool = true;
        while (bigBool) {
            var indiceClassement = 0;
            var itemClassement = JSON.parse(JSON.stringify(classement[indiceClassement]));
            var equipeAdd = new Equipe (this.parties.length, this.options, [], this.joueurs);
            var joueur = this.joueurs[itemClassement.numero];
            equipeAdd.dataJoueurs.joueurs.J1 = joueur;
            equipeAdd.ggGagnes = itemClassement.equipe.ggGagnes;
            var indiceContre = indiceClassement+1;
            var bool = true;
            var numeroContre;
            
            while (bool) {
               
                numeroContre = JSON.parse(JSON.stringify(classement[indiceContre]));
               
                if (itemClassement.equipe.contre.findIndex(elt=>elt===numeroContre.numero) == -1) {
                    bool = false;
                }
                else {
                    if (indiceContre==classement.length-1) {
                        bool = false;
                    }
                    else {
                    indiceContre++;
                    }
                }
            }
            var joueurContre = this.joueurs[numeroContre.numero];
            equipeAdd.dataJoueurs.contre.J1 = joueurContre;
            equipeAdd.reinitJoueurs(this.joueurs);
            newpartie.equipes.push(equipeAdd);
            classement.splice(indiceClassement,1);
            classement.splice(indiceContre-1,1);
            if (classement.length==0)
                bigBool = false;
        }
        
        if (lastEquipeWin!=null)
            newpartie.equipes.push(lastEquipeWin);
        
        newpartie.checkErrorGG();
        
        this.parties.push(newpartie);
        
        this.saveJSON();
      
        this.remplieLesCooequipiers();
       
    }

    addPartieGG() {
        /* En fait l'idée est de simuler autant de partie qu'il y a de joueurs qui ont gagnés
        0 parties, 1 parties 2 partes .... */
        this.nbParties ++;
        if (this.options.mode =="FORME" && this.options.GG && this.options.allEquipePlay) {
            this.addPartieGGByGA();
        }
        else {
            
            
            var resteJoueurs = [];
            
            var newpartie = new Partie(this.parties.length, this.options, [], []);
            for (var nbGagnes = 0; nbGagnes<= this.parties.length ;nbGagnes++) {
                resteJoueurs[nbGagnes] = [];
                var partie = this.getPartieWithJoueursByNbParties(nbGagnes,  resteJoueurs[nbGagnes]);
                
                partie.equipes.forEach(equipe=>{
                    equipe.ggGagnes = nbGagnes;
                    equipe.reinitJoueurs(this.joueurs);
                    
                    newpartie.equipes.push(equipe);
                })
                
            }
        
            var indiceResteJoueur = 0;
            
            resteJoueurs.forEach((resteJoueursItem, indiceGG)=>{
                while (resteJoueursItem.length > 0) {
                    var equipeAdd = new Equipe (this.parties.length, this.options, [], this.joueurs);
                    var joueur = this.joueurs[resteJoueursItem[indiceResteJoueur]];
                    equipeAdd.dataJoueurs.joueurs.J1 = joueur;
                
                    equipeAdd.ggGagnes = indiceGG;
                    equipeAdd.reinitJoueurs(this.joueurs);
                    newpartie.equipes.push(equipeAdd);
                    resteJoueursItem.splice(indiceResteJoueur, 1);
                }
            })
        
            
            
            this.parties.push(newpartie);
            this.checkError();
            this.saveJSON();
            
            this.remplieLesCooequipiers();
        }
        return this.nbParties - 1;
    }
    getPartieWithJoueursByNbParties(gagne, resteJoueurs) {
       
        var joueursByNbPartiesGagnes = [];
        var abandonJoueurs = [];
        this.joueurs.forEach((joueur, indexJoueur)=>{
            var joueurAbandon = false;
            if (typeof(this.options.abandonJoueurs)!="undefined")
                joueurAbandon = typeof(this.options.abandonJoueurs[joueur.numero])!="undefined"
            
                if (this.options.mode == 'FORME') {
                    if (typeof(this.options.joueurs[joueur.numero])!="undefined")
                        if (this.options.joueurs[joueur.numero].meneur)
                            if (joueur.gagnes  == gagne) {
                                if (joueurAbandon)
                                    abandonJoueurs.push(joueur.numero)
                                else
                                    joueursByNbPartiesGagnes.push(joueur);
                            }
                }
                else if (joueur.gagnes  == gagne) {
                    if (joueurAbandon)
                        abandonJoueurs.push(joueur.numero)
                    else
                        joueursByNbPartiesGagnes.push(joueur);
                }
            
        })
        
        var numeroRestantJoueurs = []
        var index = 0;
        joueursByNbPartiesGagnes.forEach(joueurItem=>{
            numeroRestantJoueurs[index] = joueurItem.numero;
            index++;
        });
        var options = JSON.parse(JSON.stringify(this.options));
       
       // options.allEquipePlay = true
       
        var partie = new Partie (this.parties.length, options, numeroRestantJoueurs, this.joueurs);
        partie.init();
        abandonJoueurs.forEach(numero=>{
            var equipeAdd = new Equipe (this.parties.length, this.options, [], this.joueurs);
            var joueur = this.joueurs[numero];
            equipeAdd.dataJoueurs.joueurs.J1 = joueur;
            equipeAdd.dataJoueurs.contre.J1 = null;
            equipeAdd.score.joueurs = 7;
            equipeAdd.score.contre = 13;
            equipeAdd.reinitJoueurs(this.joueurs);
            partie.equipes.push(equipeAdd);
        })
        numeroRestantJoueurs.forEach(value=>{
            resteJoueurs.push(value);
        })
        partie.checkError();
        return partie;
    }
    addPartieComplementaire() {
     
        if (this.options.addPartie && !this.options.allEquipePlay) {
            
            var joueursContreVide = [];
     
            this.joueurs.forEach((joueur, indexJoueur)=>{
                joueur.parties.forEach(partie=>{
                    if (partie.contre.length == 0) {
                        // En fait dans le cadre d'une partie FORME
                        // on ne met que les premiers joueurs...
                        // 
                        if (this.options.mode == "FORME") {
                            var nbJoueurs = Math.floor(this.options.joueurs.length /  this.nbJoueursParEquipeOption);
                            if (indexJoueur < nbJoueurs)
                                joueursContreVide[joueur.numero] = joueur;
                        }
                        else    
                            joueursContreVide[joueur.numero] = joueur;
                    }
                })
            })
            
            var numeroRestantJoueurs = []
            /*for (var index=0;index< joueursContreVide.length;index++) {
                numeroRestantJoueurs[index] = joueursContreVide[index].numero;
            }*/
            var index = 0;
            for (var value in joueursContreVide) {
               
                numeroRestantJoueurs[index] = parseInt(value);
                index++;
            }
         
            //var tirage = new Tirage (this.options);
            var options = JSON.parse(JSON.stringify(this.options));
            options.allEquipePlay = true;
            if (this.options.mode == "FORME") {
                options.nbJoueursParEquipe = 1;
            }
            var partie = new Partie (this.parties.length, options, numeroRestantJoueurs, joueursContreVide);
            
            partie.init();
            partie.checkError();
            partie.complementaire = true;
            this.parties.push(partie);
          
            this.remplieLesCooequipiers();
            this.saveJSON();
          
        } 
    }
    remplieLesCooequipiers() {
        if (this.options.mode == "FORME") {
            this.options.nbJoueursParEquipe = this.nbJoueursParEquipeOption;
            this.nbJoueurs = this.options.joueurs.length;
            this.parties.forEach(partie=>{
                partie.equipes.forEach(equipe=>{
                    for (var key in equipe.dataJoueurs) {
                        var equipeVS = equipe.dataJoueurs[key];
                       
                        if (equipeVS["J1"]!=null) {
                            var meneur = equipeVS["J1"].numero;
                            
                            if (this.options.joueurs[meneur].coequipier1 != null) { 
                                var joueurJ2 = new Joueur (this.options, this.options.joueurs[meneur].coequipier1);
                                equipe.dataJoueurs[key]["J2"] = joueurJ2;
                            }
                            if (this.options.joueurs[meneur].coequipier2 != null) {
                                var joueurJ3 = new Joueur (this.options, this.options.joueurs[meneur].coequipier2);
                                equipe.dataJoueurs[key]["J3"] = joueurJ3;
                            }
                        }
                     
                        
                        //equipe.reinitJoueurs(this.joueurs);
                    }
                })
            })

            this.saveJSON();
            // Il faut encore reunitialiser la tableau des joueurs
            
           this.initDatasFromPartiesJSON(this.options, this.partiesJSON);
           //this.saveJSON();
         
           //this.initDatasFromPartiesJSON(this.options, this.partiesJSON);
           this.saveJSON();
         
        }
    }
    addJoueur (joueurData, startIndexPartie) {
        var joueur = new Joueur(this.options, joueurData.numero);
        
        this.joueurs[joueur.numero] = joueur;
        
        var partieEquipe = [];
        
        for (var indexPartie = startIndexPartie ; indexPartie<this.parties.length ; indexPartie++) {
          var partie = this.parties[indexPartie];
         
            if (this.options.nbJoueursParEquipe == 2 && this.options.allEquipePlay) {
               
                var findEquipe = Equipe.findEquipeForTriplette (joueur, partie.equipes); // donne moi l'indice equipe & key & joueur
                if (findEquipe.indexEquipe !=null) {
                    partie.equipes[findEquipe.indexEquipe].dataJoueurs[findEquipe.key].J3 = joueur;
                    partie.equipes[findEquipe.indexEquipe].reinitJoueurs(this.joueurs);
                    var partieEquipeItem = {
                        indiceEquipe : findEquipe.indexEquipe,
                        equipe: partie.equipes[findEquipe.indexEquipe]
                    }
                    partieEquipe[indexPartie] = partieEquipeItem;
                }
                else {
                    var equipe = new Equipe (indexPartie, this.options, [], this.joueurs);
                    equipe.dataJoueurs.joueurs.J1 = joueur;
                   
                    equipe.reinitJoueurs(this.joueurs);
                    partie.equipes.push(equipe);
                    var partieEquipeItem = {
                        indiceEquipe : partie.equipes.length - 1,
                        equipe: equipe
                    }
                    partieEquipe[indexPartie] = partieEquipeItem;
                }
            }
            if (this.options.nbJoueursParEquipe == 3 && this.options.allEquipePlay) {
                var findEmplacement = false;
                partie.equipes.forEach((equipe, indiceEquipe) => {
                    for (var key in equipe.dataJoueurs) {
                        for (var joueurLoop in equipe.dataJoueurs[key]) {
                            // Potentiellement il va y avoir un problème si les équipes sont complètes
                            // si c'est le cas il faut créer une nouvelle équipe et laisser l'organisateur faire ses manips
                            // ou tirer de manière aléatoire
                            if (!findEmplacement && equipe.dataJoueurs[key][joueurLoop] == null) {
                                if (Joueur.validAMI(joueur, equipe.dataJoueurs[key]) && Joueur.validCONTRE(joueur, equipe.dataJoueurs[key])) {
                                    equipe.dataJoueurs[key][joueurLoop] = joueur;
                                    equipe.reinitJoueurs(this.joueurs);
                                    findEmplacement = true;
                                    var partieEquipeItem = {
                                        indiceEquipe : indiceEquipe,
                                        equipe: equipe
                                    }
                                    partieEquipe[indexPartie] = partieEquipeItem;
                                }
                            }
                        }
                    }
                })
                if (!findEmplacement) {
                    var equipe = new Equipe (indexPartie, this.options, [], this.joueurs);
                    equipe.dataJoueurs.joueurs.J1 = joueur;
                   
                    equipe.reinitJoueurs(this.joueurs);
                    partie.equipes.push(equipe);
                    var partieEquipeItem = {
                        indiceEquipe : partie.equipes.length - 1,
                        equipe: equipe
                    }
                    partieEquipe[indexPartie] = partieEquipeItem;
                }
                
                   
            }
            if (!this.options.allEquipePlay) {
                // là on créer une nouvelle équipe où le joueur se tout seul et gagnera par défault les parties
                // à l'organisateur de modifier de changer ou de retirer un tirage
                var equipe = new Equipe (indexPartie, this.options, [], this.joueurs);
                equipe.dataJoueurs.joueurs.J1 = joueur;
                equipe.score.joueurs = this.options.ifNotFound.win;
                equipe.score.contre = this.options.ifNotFound.lose;
                equipe.reinitJoueurs(this.joueurs);
                partie.equipes.push(equipe);
                var partieEquipeItem = {
                    indiceEquipe : partie.equipes.length - 1,
                    equipe: equipe
                }
                partieEquipe[indexPartie] = partieEquipeItem;
            }
            
           

        }
     
        return partieEquipe;
    }
    addOneEquipeGG(indexPartie, equipe) {
     
        var nbJoueursByWin = [];
        var nbJoueursRepartitionByWin = [];
        var nbJoueursAllByEquipe = this.options.nbJoueursParEquipe * 2;
        var nbJoueursGagneDefault = [];
        if (this.parties[indexPartie+1].equipes.length==0) {
            // j'initialise les équipes de la partie suivante !
            var partie = this.parties[indexPartie];
            
            partie.equipes.forEach((equipeItem, indexPartieItem)=> {
                if ((equipeItem.dataJoueurs.contre.J1!=null && (this.equipeHasScore(equipeItem))) 
                                                    || 
                    (!this.equipeHasScore(equipeItem))) {
                    if (typeof(nbJoueursByWin[equipeItem.ggGagnes])=="undefined")
                        nbJoueursByWin[equipeItem.ggGagnes] = nbJoueursAllByEquipe;
                    else
                        nbJoueursByWin[equipeItem.ggGagnes] += nbJoueursAllByEquipe;
                }
                else {
                    if (parseInt(equipeItem.score.joueurs) > parseInt(equipeItem.score.contre)) {
                        if (typeof(nbJoueursGagneDefault[equipeItem.ggGagnes+1]) =="undefined")
                            nbJoueursGagneDefault[equipeItem.ggGagnes+1] = 1;
                        else
                            nbJoueursGagneDefault[equipeItem.ggGagnes+1] ++;
                        }
                    else {
                        if (typeof(nbJoueursGagneDefault[equipeItem.ggGagnes]) =="undefined")
                            nbJoueursGagneDefault[equipeItem.ggGagnes] = 1;
                        else
                           nbJoueursGagneDefault[equipeItem.ggGagnes] ++;
                    }
                }
            })
           
            nbJoueursByWin.forEach((nbJoueurByWin, indexNbJoueur)=>{
                if (indexNbJoueur == 0)
                    nbJoueursRepartitionByWin[indexNbJoueur] = nbJoueursByWin[indexNbJoueur] / 2;
                else
                    nbJoueursRepartitionByWin[indexNbJoueur] += nbJoueursByWin[indexNbJoueur] / 2;
                nbJoueursRepartitionByWin[indexNbJoueur+1] = nbJoueursByWin[indexNbJoueur] / 2 ;
            })
            nbJoueursRepartitionByWin.forEach((nbJoueurRepartitionByWin, indexJoueurRepartition)=>{
                if (!isNaN(nbJoueursGagneDefault[indexJoueurRepartition]))
                    nbJoueursRepartitionByWin[indexJoueurRepartition] += nbJoueursGagneDefault[indexJoueurRepartition];
            })
            // Du coup on a la répartition du nbs joueurs par partie gagnes
            // on peut désormais en déduire le nombre d'équipes par parties gagnes futurs!
           
            var nbEquipesRepartitionByWin = [];
            var nbEquipesRepartitionByWinDefault = [];
            nbJoueursRepartitionByWin.forEach((nbJoueurRepartitionByWin, indexJoueurRepartition)=>{
                nbEquipesRepartitionByWin[indexJoueurRepartition] =  Math.floor(nbJoueursRepartitionByWin[indexJoueurRepartition] / nbJoueursAllByEquipe);
                nbEquipesRepartitionByWinDefault[indexJoueurRepartition] = nbJoueursRepartitionByWin[indexJoueurRepartition] % nbJoueursAllByEquipe;
            })
          
            nbEquipesRepartitionByWin.forEach((nbEquipeRepartitionByWin, winRepartition)=>{
               
                for (var nbEquipe=0;nbEquipe<nbEquipeRepartitionByWin;nbEquipe++) {
                  
                    var equipeNew = new Equipe(indexPartie+1, this.options, [], this.joueurs);
                    equipeNew.ggGagnes = winRepartition;
                    this.parties[indexPartie+1].equipes.push(equipeNew);    
                }
            })
            
            nbEquipesRepartitionByWinDefault.forEach((nbEquipeRepartitionByWin, winRepartition)=>{
                if (!isNaN(nbEquipeRepartitionByWin)) {
                    for (var nbEquipe=0;nbEquipe<nbEquipeRepartitionByWin;nbEquipe++) {
                      
                        var equipeNew = new Equipe(indexPartie+1, this.options, [], this.joueurs);
                        equipeNew.score.joueurs = this.options.ifNotFound.win;
                        equipeNew.score.contre = this.options.ifNotFound.lose;
                        equipeNew.ggGagnes = winRepartition;
                        this.parties[indexPartie+1].equipes.push(equipeNew);    
                    }
                }
            })
        }
        else {
            var nbEquipesRepartitionByWin = [];
            this.parties[indexPartie+1].equipes.forEach((equipe, indexEquipe)=>{
                if (typeof(nbEquipesRepartitionByWin[equipe.ggGagnes])=="undefined") {
                    nbEquipesRepartitionByWin[equipe.ggGagnes] = 1;
                }
                else
                    nbEquipesRepartitionByWin[equipe.ggGagnes] ++;
                
            })
        }
        var arrayIndexEquipes = []
        this.parties[indexPartie+1].equipes.forEach((equipe, indexEquipe)=>{
            if (typeof(arrayIndexEquipes[equipe.ggGagnes])=="undefined")
                arrayIndexEquipes[equipe.ggGagnes] = [];
            arrayIndexEquipes[equipe.ggGagnes].push(indexEquipe);
        });
        
        // je sauvegarde tous les joueurs blanc et on sauvegarde tous les joueurs qui n'ont pas encore été sélectionné dans la prochaine partie !
        var joueursBlanc = [];
        var joueursResteASelectionne = [];
        this.joueurs.forEach(joueurItem2=>{
            
            if ((this.options.mode != "FORME") || (this.options.joueurs[joueurItem2.numero].meneur && this.options.mode=="FORME")) {
                
                joueurItem2.gagnesByPartie.forEach((partie, indexPartie2)=>{
                    if (joueurItem2.parties[indexPartie2].contre.length == 0)
                        joueursBlanc.push(joueurItem2.numero);
                })
            }
        })
       
        arrayIndexEquipes.forEach((equipeIndexReste, win)=>{
            
            equipeIndexReste.forEach(equipeIndexResteItem=>{
                var equipeItem = this.parties[indexPartie+1].equipes[equipeIndexResteItem];
                if (typeof(joueursResteASelectionne[win])=="undefined")
                joueursResteASelectionne[win] = 0;    
                joueursResteASelectionne[win] += this.nbPutJoueur(equipeItem);
            })
        })
     
        this.joueurs.forEach(joueurItem=>{
                 if ((this.options.mode != "FORME") || (this.options.joueurs[joueurItem.numero].meneur && this.options.mode=="FORME")) {
                if (typeof(joueurItem.parties[indexPartie+1]) == "undefined") {
                    // on va regarder si il a gagné à sa précedente partie
                    if (typeof(joueurItem.gagnesByPartie[indexPartie]) != "undefined") {
                       var forcage;
                        var jsonEquipe = this.findEquipeGG(indexPartie+1, joueurItem, arrayIndexEquipes, joueurItem.gagnesByPartie[indexPartie], forcage,joueursBlanc,joueursResteASelectionne) ;
                        if (jsonEquipe == null)
                            jsonEquipe = this.findEquipeGG(indexPartie+1, joueurItem, arrayIndexEquipes, joueurItem.gagnesByPartie[indexPartie], 2, joueursBlanc,joueursResteASelectionne);
                        if (jsonEquipe == null)
                            jsonEquipe = this.findEquipeGG(indexPartie+1, joueurItem, arrayIndexEquipes, joueurItem.gagnesByPartie[indexPartie], 3, joueursBlanc,joueursResteASelectionne);
                        if (jsonEquipe == null)
                            jsonEquipe = this.findEquipeGG(indexPartie+1, joueurItem, arrayIndexEquipes, joueurItem.gagnesByPartie[indexPartie], 4, joueursBlanc,joueursResteASelectionne);
                        
                        this.parties[indexPartie+1].equipes[jsonEquipe.indexEquipe].dataJoueurs[jsonEquipe.key][jsonEquipe.joueur] = {
                            error: null,
                            errorDetail: {},
                            numero: joueurItem.numero
                        }
                        this.parties[indexPartie+1].equipes[jsonEquipe.indexEquipe].reinitJoueurs(this.joueurs);
                        
                        /*if (jsonEquipe !=null) 
                            this.arrayIndexEquipes[joueurItem.gagnesByPartie[indexPartie]].splice(jsonEquipe.indexAlea,1)
                        */
                    }
                }
            }
        })

       // this.parties[indexPartie+1].
        this.saveJSON();
        this.remplieLesCooequipiers();
        return this.partiesJSON[indexPartie+1];
        
    }
    nbPutJoueur(equipe) {
        var compteurJoueursInEquipe = 0;
        for (var key in equipe.dataJoueurs) {
            for (var joueur in equipe.dataJoueurs[key])
                if (equipe.dataJoueurs[key][joueur] != null)
                    compteurJoueursInEquipe ++;
        }
        if (this.equipeHasScore(equipe))
            if (compteurJoueursInEquipe==1)
                return 0;
            else
                return 1;
        else
            return (this.options.nbJoueursParEquipe*2) - compteurJoueursInEquipe;
    }
    verifEquipe(joueurItem, joueur, key, score, indexPartie, joueursBlanc, forcage) {
        
        var flag = true;
        if (joueur == "J3" && this.options.nbJoueursParEquipe!=3)
            flag = false;
        else if (joueur == "J2" && this.options.nbJoueursParEquipe!=2)
            flag = false;
        else if (joueur != "J1" && key=="joueurs" && (score!=null && score!=""))
            flag = false;
        else if (key=="contre" && (score!=null && score!=""))
            flag = false;
        else if(joueur == "J1" && key=="joueurs" && (score!=null && score!="") && forcage!=4) {
            // il faut vérifier que le gars n'a pas déjà joué de jeu blanc !!!!
            if (joueursBlanc.indexOf(joueurItem.numero)!=-1)
                flag = false;
        }
        
        return flag;
    }
    findAleaEquipeGG(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec, joueursBlanc, joueursResteASelectionne) {
        // je regarde le nombre de jeu à blanc  (dans les jeux qui restent)
        var arrayEquipesBlanche = [];
       
        arrayIndexEquipesParam[nbGagnePartiePrec].forEach((equipeIndexItem)=>{
            var equipeItem = this.parties[indexPartie].equipes[equipeIndexItem];
            if (equipeItem.dataJoueurs.joueurs == null && this.equipeHasScore(equipeItem))
                arrayEquipesBlanche.push(equipeIndexItem)
        })
        // parmis les joueurs qui restent (donc à partir de joueurItem)
      
        var resteJoueursSuffisants = (joueursResteASelectionne[nbGagnePartiePrec] - joueursBlanc.length) - arrayEquipesBlanche.length;
       
        var jsonReturn = {};
        var findIndexEquipe = null;
        if (resteJoueursSuffisants <=0 && arrayEquipesBlanche.length>0) {
            // mon joueur a déjà joué une partie blanche
            if (joueursBlanc.indexOf(joueurItem.numero)!=-1) {
                arrayIndexEquipesParam[nbGagnePartiePrec].forEach(indexEquipe=>{
                    if (findIndexEquipe==null) {
                        if (arrayEquipesBlanche.indexOf(indexEquipe)==-1) {
                            findIndexEquipe = indexEquipe;
                        }
                    }
                })
            }
            // si mon joueur n'a pas joué une partie blanche il faut lui forcer une équipe à blanche
            else {
                arrayIndexEquipesParam[nbGagnePartiePrec].forEach(indexEquipe=>{
                    if (findIndexEquipe==null) {
                        if (arrayEquipesBlanche.indexOf(indexEquipe)!=-1) {
                            findIndexEquipe = indexEquipe;
                        }
                    }
                })
            }
            jsonReturn = {
                indexAlex: arrayIndexEquipesParam[nbGagnePartiePrec].indexOf(findIndexEquipe),
                indexEquipe: findIndexEquipe
            }
        }
        else {
            var nbEquipe = arrayIndexEquipesParam[nbGagnePartiePrec].length;
            var indexAlea = Math.floor(Math.random() * Math.floor(nbEquipe))
            jsonReturn = {
                indexAlea : indexAlea,
                indexEquipe: arrayIndexEquipesParam[nbGagnePartiePrec][indexAlea]
            }
        }
       
        return jsonReturn;
    }
    findEquipeGG(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec, forcage, joueursBlanc, joueursResteASelectionne) {
       
        var nbEquipe = arrayIndexEquipesParam[nbGagnePartiePrec].length;
        var jsonAleaFind = this.findAleaEquipeGG(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec, joueursBlanc, joueursResteASelectionne);
        
        var indexAlea = jsonAleaFind.indexAlea;
        var jsonEquipe = null;
       
        if (nbEquipe==0) {
           
            return null;
        }
            
       
        var indexEquipe = jsonAleaFind.indexEquipe;
     
        var equipe = this.parties[indexPartie].equipes[indexEquipe];
        var find = false;
        for (var key in equipe.dataJoueurs) {
            if (!find) {
                for (var joueur in equipe.dataJoueurs[key]) {
                    
                    if (!find) {
                       
                        var verif = this.verifEquipe(joueurItem, joueur, key, equipe.score.joueurs, indexPartie, joueursBlanc, forcage);
                    
                      
                    if (verif) {

                        if (equipe.dataJoueurs[key][joueur] == null) {
                            
                            if (key =="joueurs") {
                                if (
                                    (Joueur.validAllEquipe(joueurItem, equipe.dataJoueurs)
                                        || forcage > 0)
                                    &&
                                    (Joueur.validCONTRE(joueurItem, equipe.dataJoueurs.contre, forcage)
                                            || forcage == 3) 
                                    && 
                                    (Joueur.validAMI(joueurItem, equipe.dataJoueurs.joueurs, forcage)
                                            || forcage == 2)
                                            ) {
                                    jsonEquipe={
                                        indexEquipe: indexEquipe,
                                        key: key,
                                        joueur: joueur,
                                        indexAlea: indexAlea
                                    }
                                    find = true;
                                }
                            }
                            else {
                                if (
                                (Joueur.validAllEquipe(joueurItem, equipe.dataJoueurs)
                                        || forcage > 0)
                                &&
                                (Joueur.validCONTRE(joueurItem, equipe.dataJoueurs.joueurs, forcage)
                                    || forcage == 3) 
                                && 
                                (Joueur.validAMI(joueurItem, equipe.dataJoueurs.contre, forcage)
                                    || forcage == 2)
                                ) {
                                    jsonEquipe={
                                        indexEquipe: indexEquipe,
                                        key: key,
                                        joueur: joueur,
                                        indexAlea: indexAlea
                                    }
                                    find = true;
                                }
                            }
                        }
                    }
                    }
                }
            }
        }
    
        if (jsonEquipe==null) {
            var arrayContruct = JSON.parse(JSON.stringify(arrayIndexEquipesParam));
            arrayContruct[nbGagnePartiePrec].splice(indexAlea, 1);
            
            return this.findEquipeGG(indexPartie, joueurItem, arrayContruct, nbGagnePartiePrec, forcage, joueursBlanc, joueursResteASelectionne);
        }
        else
            return jsonEquipe;
    }
    findJoueur(partie, numero) {
        var joueur = null;
        partie.equipes.forEach(equipe=>{
            for (var type in equipe.dataJoueurs) {
                for (var j in equipe.dataJoueurs[type])
                    if (equipe.dataJoueurs[type][j] != null) {
                        if (equipe.dataJoueurs[type][j].numero == numero)
                            joueur = equipe.dataJoueurs[type][j];
                    }
            }
       })
       return joueur;
    }
    
    addOneEquipeGGAllPlay (indexPartie, equipe, forcageBig, forcage) {
        var indexNouvellePartie = indexPartie+1;
        var partiePrecFinish = true;
        if (indexPartie>0) {
            partiePrecFinish = this.parties[indexPartie-1].state == "FINISH";
        }
        if (partiePrecFinish) {
            // On teste si la nouvelle partie a été déjà été crée !!!
            
            // Si ce n'est pas crée il faut du coup initialiser toutes les équipes
            // et créer autant de parties qui est possible !!!

            // pour cela il faut savoir combien de joueurs on a par groupe de partie gagnés
            // on va commencer par ça !
            var partieFinish = {};
            var nbEquipesByGGNextParties = [];
            if (typeof(forcageBig)=="undefined") 
                    forcageBig = {};
            if (typeof(forcage)=="undefined")
                forcage = 0;
            this.parties[indexPartie].equipes.forEach(equipe=>{
                
                var ggGagnes = equipe.ggGagnes;
                
                if (typeof(forcageBig[ggGagnes])=="undefined")
                    forcageBig[ggGagnes]=false;             
                partieFinish[ggGagnes] = true;
                if (typeof(nbEquipesByGGNextParties[ggGagnes])=="undefined")
                    nbEquipesByGGNextParties[ggGagnes] = {
                        min: 0,
                        max: 0
                    };
                if (typeof(nbEquipesByGGNextParties[ggGagnes+1])=="undefined")
                    nbEquipesByGGNextParties[ggGagnes+1] = {
                        min: 0,
                        max: 0
                    };
                var nbJoueurs = 0;
                if (!this.equipeHasScore(equipe)) {
                    for (var type in equipe.dataJoueurs) {
                        for (var j in equipe.dataJoueurs[type])
                            if (equipe.dataJoueurs[type][j] != null)
                                nbJoueurs++;
                    }
                    var nbJoueursAfter = Math.floor(nbJoueurs/2);
                    var resteJoueurs = nbJoueurs % 2;
                    nbEquipesByGGNextParties[ggGagnes].min += nbJoueursAfter;
                    nbEquipesByGGNextParties[ggGagnes].max += nbJoueursAfter + resteJoueurs;
                    nbEquipesByGGNextParties[ggGagnes+1].min += nbJoueursAfter;
                    nbEquipesByGGNextParties[ggGagnes+1].max += nbJoueursAfter + resteJoueurs;
                }
                else {
                    var gagne = equipe.score["joueurs"]>equipe.score["contre"] ? "joueurs" : "contre";
                    var perdu = gagne == "joueurs" ? "contre" : "joueurs";
                    for (var j in equipe.dataJoueurs[gagne])
                        if (equipe.dataJoueurs[gagne][j] != null)
                            nbJoueurs++;
                    nbEquipesByGGNextParties[ggGagnes+1].min += nbJoueurs;
                    nbEquipesByGGNextParties[ggGagnes+1].max += nbJoueurs;
                    nbJoueurs = 0;
                    for (var j in equipe.dataJoueurs[perdu])
                    if (equipe.dataJoueurs[perdu][j] != null)
                        nbJoueurs++;
                    nbEquipesByGGNextParties[ggGagnes].min += nbJoueurs;
                    nbEquipesByGGNextParties[ggGagnes].max += nbJoueurs;
                }
            })
            
            if (this.parties[indexNouvellePartie].equipes.length==0) {
                nbEquipesByGGNextParties.forEach((nbEquipesACreer, ggGagnes)=>{
                    var nbEquipes =  Math.floor(nbEquipesACreer.min/4);
                    if (nbEquipes<1)
                        nbEquipes++;
                    var resteEquipes = nbEquipesACreer.min % 4;
                    var resteEquipesMax = nbEquipesACreer.max % 4;
                    
                    for (var indiceEquipe = 0;indiceEquipe<nbEquipes;indiceEquipe++) {
                        var newEquipe =  new Equipe(indexNouvellePartie, this.options, [], this.joueurs);
                        newEquipe.ggGagnes = ggGagnes;
                        newEquipe.exist = false;
                        if (nbEquipesACreer.min != nbEquipesACreer.max) {
                            if (indiceEquipe<2) {
                                var nbTriplette = 0;
                                // Si le reste de MAX alors cela signifie qu'il est possible de devoir créer une équipe SUP !
                                // du coup on ne renseigne pas le nbTriplette
                                // sinon on peut déjà à minima mettre le nombre de triplette par rapport au min
                                if (resteEquipesMax==0)
                                    nbTriplette = 0;
                                else {
                                    if (indiceEquipe==0)
                                        nbTriplette = (resteEquipes>2) ? 2 : resteEquipes;
                                    if (indiceEquipe==1)
                                        nbTriplette = (resteEquipes>2) ? 1 : 0;
                                }
                                newEquipe.triplette = {
                                    nb: nbTriplette,
                                    state: false
                                }
                            }
                            else {
                                newEquipe.triplette = {
                                    nb: 0,
                                    state: true
                                }
                            }
                        }
                        else {
                            if (indiceEquipe==0 && resteEquipes > 0) {
                                    var resteEquipeCalcul = (resteEquipes > 2) ? 2 : resteEquipes;
                                    newEquipe.triplette = {
                                        nb: resteEquipeCalcul,
                                        state: true
                                    }
                            }
                            else if (indiceEquipe==1 && resteEquipes > 2) {
                                var resteEquipeCalcul = (resteEquipes > 2) ? 1 : 0;
                                    newEquipe.triplette = {
                                        nb: resteEquipeCalcul,
                                        state: true
                                    }
                                }
                            else {
                                    newEquipe.triplette = {
                                        nb: 0,
                                        state: true
                                    }
                                }
                        }
                        
                        this.parties[indexNouvellePartie].equipes.push(newEquipe);
                    }
                    
                })
            }

            
            nbEquipesByGGNextParties.forEach((nbEquipesACreer, ggGagnes)=>{
                
                    
                if (nbEquipesACreer.min == nbEquipesACreer.max) {
                    var nbEquipes =  Math.floor(nbEquipesACreer.max/4);
                    var resteEquipes = nbEquipesACreer.max % 4;
                    var nbEquipeGG=0;
                    
                    this.parties[indexNouvellePartie].equipes.forEach(equipe=>{
                        if (!equipe.triplette.state && equipe.ggGagnes == ggGagnes) {
                            equipe.triplette.nb = (resteEquipes == 3) ? 2 : resteEquipes;
                            equipe.triplette.state = true;
                            equipe.exists = true;
                            resteEquipes -= equipe.triplette.nb;
                        }
                        if (equipe.ggGagnes == ggGagnes)
                            nbEquipeGG++;
                        
                    })
                    if (nbEquipeGG<nbEquipes) {
                        var newEquipe = new Equipe(indexNouvellePartie, this.options, [], this.joueurs);
                        newEquipe.ggGagnes = ggGagnes;
                        newEquipe.exist = false; 
                        newEquipe.triplette = {
                            nb: 0,
                            state: true
                        }
                        this.parties[indexNouvellePartie].equipes.push(newEquipe);
                    }
                    if (resteEquipes==1 && nbEquipeGG==1) {
                        var newEquipe = new Equipe(indexNouvellePartie, this.options, [], this.joueurs);
                        newEquipe.ggGagnes = ggGagnes;
                        newEquipe.exist = false; 
                        newEquipe.triplette = {
                            nb: 1,
                            state: true
                        }
                        this.parties[indexNouvellePartie].equipes.push(newEquipe);
                    }
                }
            })
            var equipeLibre = {};
            var joueurADejaJoueEnTriplette = {};
            var indiceEquipesByGG = []
            this.parties[indexNouvellePartie].equipes.forEach((equipe, indiceEquipe)=>{
                    var equipeTripletteComplete = false;
                    if (typeof(equipeLibre[equipe.ggGagnes])=="undefined")
                        equipeLibre[equipe.ggGagnes]={
                            doublette : 0,
                            triplette : 0
                        };
                    var calculeTriplette = true;
                    for (var type in equipe.dataJoueurs) {
                        for (var j in equipe.dataJoueurs[type]) {
                            if (equipe.triplette.nb==0) {
                                if (equipe.dataJoueurs[type][j] == null && j!="J3")
                                    equipeLibre[equipe.ggGagnes].doublette++;
                            }
                            if (equipe.triplette.nb==2) {
                                if (equipe.dataJoueurs[type][j] == null)
                                    equipeLibre[equipe.ggGagnes].triplette++;
                            }
                            if (equipe.triplette.nb==1) {
                                if (equipe.dataJoueurs[type][j] == null && !calculeTriplette) {
                                    equipeLibre[equipe.ggGagnes].triplette++;
                                    calculeTriplette = false;
                                }
                            }
                        }
                    }
                    if ((equipe.dataJoueurs["joueurs"]["J3"] != null || (equipe.dataJoueurs["contre"]["J3"] != null)) && equipe.triplette.nb==1) {
                        equipeTripletteComplete = true;
                    }
                    if (equipe.dataJoueurs["joueurs"]["J3"] == null && equipe.triplette.nb==1 && !equipeTripletteComplete) {
                        tripletteLibre[equipe.ggGagnes]++;
                    }
                    if (equipe.dataJoueurs["joueurs"]["J3"] == null && equipe.triplette.nb==1 && !equipeTripletteComplete) {
                        tripletteLibre[equipe.ggGagnes]++;
                    }
                    
                    if ((equipe.dataJoueurs["joueurs"]["J3"] == null && (equipe.dataJoueurs["contre"]["J3"] == null)) && equipe.triplette.nb==2) {
                        tripletteLibre[equipe.ggGagnes] += 2;
                    }
                    else if ((equipe.dataJoueurs["joueurs"]["J3"] == null || (equipe.dataJoueurs["contre"]["J3"] == null)) && equipe.triplette.nb==2) {
                        tripletteLibre[equipe.ggGagnes]++;
                    }

                    if (typeof(indiceEquipesByGG[equipe.ggGagnes])=="undefined")
                        indiceEquipesByGG[equipe.ggGagnes] = [];
                    indiceEquipesByGG[equipe.ggGagnes].push(indiceEquipe);
                    
            })
            //this.parties[indexPartie+1].equipes[jsonEquipe.indexEquipe].reinitJoueurs(this.joueurs);
        // this.parties[indexPartie+1].
        
       
        
        this.joueurs.forEach(joueurItem=>{
            if (joueurItem.parties.length-1!=indexNouvellePartie) {
                if (joueurItem.aDejaJoueEnTriplette()) {
                    if (typeof(joueurADejaJoueEnTriplette[joueurItem.gagnes])=="undefined")
                        joueurADejaJoueEnTriplette[joueurItem.gagnes]=[];
                    if (typeof(joueurADejaJoueEnTriplette[joueurItem.gagnes+1])=="undefined")
                        joueurADejaJoueEnTriplette[joueurItem.gagnes+1]=[];
                    joueurADejaJoueEnTriplette[joueurItem.gagnes].push(joueurItem.numero)
                    joueurADejaJoueEnTriplette[joueurItem.gagnes+1].push(joueurItem.numero)
                }
            }
        })
        
        // On va prendre chaque joueur gagné pour l'affecter dans la nouvelle partie
        var pasTouslesJoueurs = {};
        
        this.parties[indexPartie].equipes.forEach(equipe=>{
                var ggGagnes = equipe.ggGagnes;
                var prioriteTriplette = false;
               
                var hasScore = this.equipeHasScore(equipe);
                if (!hasScore)
                    partieFinish[ggGagnes] = false;
                for (var type in equipe.dataJoueurs) {
                    for (var j in equipe.dataJoueurs[type])
                        if (equipe.dataJoueurs[type][j] != null) {
                            var vsType = (type == "joueurs") ? "contre" : "joueurs";
                            if (equipe.score[type] > equipe.score[vsType])
                                ggGagnes = equipe.ggGagnes+1;
                            else
                                ggGagnes = equipe.ggGagnes;
                            
                            
                            if (typeof(pasTouslesJoueurs[ggGagnes])=="undefined")
                                pasTouslesJoueurs[ggGagnes] = [];
                            var numeroJoueur = equipe.dataJoueurs[type][j].numero;
                            if (typeof(joueurADejaJoueEnTriplette[ggGagnes])!="undefined")
                                if (joueurADejaJoueEnTriplette[ggGagnes].length>tripletteLibre[ggGagnes]-2) {
                                    if (joueurADejaJoueEnTriplette[ggGagnes].indexOf(numeroJoueur)==-1)
                                        prioriteTriplette = true;
                            }
                                
                            var joueurItem = this.joueurs[equipe.dataJoueurs[type][j].numero];
                            // on va tenter de trouver le numéro du joueur dans la partie à créer
                            var joueurNext = this.findJoueur(this.parties[indexNouvellePartie], numeroJoueur);
                            // si c'est pas null cest qu'on l'a trouver
                            // si on un socre et que le joueur n'est pas null alors il faut supppmier le joueur dans la prochaine partie !
                            if (hasScore) {
                                if (joueurNext!=null)
                                    joueurNext = null;
                                else {
                                    
                                    
                                    var findEquipe = null;
                                   
                                    var tabEquipes = JSON.parse(JSON.stringify(indiceEquipesByGG))
                                    if (!prioriteTriplette)
                                        findEquipe = this.findEquipeAleaGG(indexNouvellePartie, numeroJoueur, tabEquipes, ggGagnes, forcage);
                                  
                                    if (!forcageBig[ggGagnes] && findEquipe==null)
                                        pasTouslesJoueurs[ggGagnes].push(numeroJoueur);
                                    
                                    
                                    if (findEquipe != null)
                                        this.parties[indexNouvellePartie].equipes[findEquipe.indice].dataJoueurs[findEquipe.type][findEquipe.joueur] = joueurItem;
                                }
                            }

                        }
                }
        })
        var forcageBigNew=[];
        var forcageBoolean = false;
        for (var gg in pasTouslesJoueurs) {
                if (!forcageBig[gg]) {
                    var ggAvt = gg - 1;
                    if (ggAvt < 0)
                        ggAvt = 0;
                    if (partieFinish[ggAvt] && pasTouslesJoueurs[gg].length!=0) {
                        forcageBigNew[gg] = true;
                        forcageBoolean = true;
                    }
                }
        }
        
        if (forcageBoolean && forcage<5)
                this.addOneEquipeGGAllPlay (indexPartie, equipe, forcageBigNew, forcage++);
        
        this.parties[indexNouvellePartie].checkError();
        this.saveJSON();
        
        return this.partiesJSON[indexNouvellePartie];
        }
        else {
            return null;
        }
    }
    findEmplacementInEquipe (equipe, joueurItem, forcage, nb) {
      
        var triplette = false;
        var arrayType = ["joueurs", "contre"];
        var arrayJoueurs = ["J1", "J2"];
        var indiceArrayType = Math.floor(Math.random() * arrayType.length);
        if (typeof(equipe.triplette)!="undefined") {
            // ICI je regarde si je peux le mettre en joueur J3
            if ((equipe.triplette.nb == 1 || equipe.triplette.nb==3) && indiceArrayType == 0)
                arrayJoueurs.push("J3") 
            if (equipe.triplette.nb == 2)
                arrayJoueurs.push("J3")
             
        }
        
        var indiceArrayJoueurs = Math.floor(Math.random() * arrayJoueurs.length);

       
        if (nb==0) {
            return -1;
        } 
        if (typeof(nb)=="undefined")
            nb=0;
        if (nb>6) {
            
            // "du coup on force le destin !!!";
            
            nb=-1;
            if (forcage>3) {
                var findOK = false;
                for (var type in equipe.dataJoueurs)
                    for (var vs in equipe.dataJoueurs[type]) {
                        if (!findOK) {
                            if (vs=="J3") 
                            {
                                if ((equipe.triplette.nb==1 || equipe.triplette.nb==3) 
                                            && (type=="joueurs")) {
                                    if (equipe.dataJoueurs[type][vs] == null) {
                                        indiceArrayType  = 0;
                                        indiceArrayJoueurs = 2
                                        findOK = true;
                                    }
                                }
                                if (!findOK && equipe.triplette.nb==2) {
                                    if (equipe.dataJoueurs[type][vs] == null) {
                                        indiceArrayType  = 1;
                                        indiceArrayJoueurs = 2
                                        findOK = true;
                                    }
                                }
                            }
                            else if (!findOK && equipe.dataJoueurs[type][vs] == null) {
                                indiceArrayType  = arrayType.indexOf(type);
                                indiceArrayJoueurs  = arrayJoueurs.indexOf(vs);
                                findOK = true;
                            }
                        }
                    }
            }
        }
       
       
        var choiceType = arrayType[indiceArrayType];
        var choiceJoueur = arrayJoueurs[indiceArrayJoueurs];
        var findOK = false;
        var triplettePossible = (arrayJoueurs.length==3 && !joueurItem.aDejaJoueEnTriplette()) || arrayJoueurs.length!=3
        var vsType = (choiceType == "joueurs") ? "contre" : "joueurs";
        if (equipe.dataJoueurs[choiceType][choiceJoueur]==null) {
            if (Joueur.validAllEquipe(joueurItem, equipe.dataJoueurs)  && forcage==0 && triplettePossible ) {
                findOK = true;
            }
            if (forcage==1 && Joueur.validAMI(joueurItem, equipe.dataJoueurs[choiceType]) && triplettePossible ) {
                findOK = true;
            }
            if (forcage==2 && Joueur.validCONTRE(joueurItem, equipe.dataJoueurs[vsType]) && triplettePossible ) {
               findOK = true;
            }
            if (forcage==3 && triplettePossible ) {
                    findOK = true;
            } 
            if (forcage == 4) {
                
                findOK = true;
            }
        }
       
        if (findOK) {
           
            return {
                type: choiceType,
                joueur: choiceJoueur
            }
        }
        else
            return this.findEmplacementInEquipe(equipe, joueurItem, forcage, nb+1);
        
    }
    findEquipeAleaGG(index, numeroJoueur, tabEquipes, ggGagnes, forcage) {
        // bon c'est nouveau /// 07/2022    


        if (tabEquipes[ggGagnes].length==0)
            return null;
        else {
            if (typeof(forcage)=="undefined")
                forcage = 0;
            var indiceTabEquipe = Math.floor(Math.random() * Math.floor(tabEquipes[ggGagnes].length));
            var indiceEquipe = tabEquipes[ggGagnes][indiceTabEquipe];
            
            var equipeFind = this.parties[index].equipes[indiceEquipe];
            var joueurItem = this.joueurs[numeroJoueur]
            var equipeJoueur = this.findEmplacementInEquipe(equipeFind, joueurItem, forcage);
            
            if (equipeJoueur!=-1) {
                return {
                    indice: indiceEquipe,
                    type: equipeJoueur.type,
                    joueur: equipeJoueur.joueur
                }
            }
            else
                {
                    
                    tabEquipes[ggGagnes].splice(indiceTabEquipe, 1);
                    return this.findEquipeAleaGG(index, numeroJoueur, tabEquipes, ggGagnes, forcage);
                }
        }
    }
    equipeHasScore(equipe) {
        // return true si le score est renseigné
        // false si le score n'est pas renseigné
        var val = parseInt(equipe.score.joueurs);
        if (!isNaN(val))
            return true;
        else
            return equipe.score.joueurs != null && equipe.score.joueurs != '';
    }
    findAleaJoueursAllPlay(arrayJoueurs, joueurItem, nbTripletteJoueur, forcage) {
        
        var indice = Math.floor(Math.random() * Math.floor(arrayJoueurs.length));
        
        if (arrayJoueurs.length==0)
            return -1;
        else if (arrayJoueurs[indice]=="J3") {
            if (nbTripletteJoueur.indexOf(joueurItem.numero)==-1)
                return indice;
            else if (forcage == 4)
                return indice;
            else {
                var arrayJoueursTempo = JSON.parse(JSON.stringify(arrayJoueurs));
                arrayJoueursTempo.splice(indice, 1);   
                return this.findAleaJoueursAllPlay(arrayJoueursTempo, joueurItem, nbTripletteJoueur, forcage)
            }
        }
        else
            return indice;
    }
    findEquipeGGAllPlay(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec, forcage, nbTriplette, nbTripletteJoueur, joueursResteASelectionne) {
        
        if (typeof(arrayIndexEquipesParam[nbGagnePartiePrec])=="undefined")
            return null;
        var nbEquipe = arrayIndexEquipesParam[nbGagnePartiePrec].length;
        var jsonAleaFind = this.findAleaEquipeGGAllPlay(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec,  forcage, nbTriplette, nbTripletteJoueur, joueursResteASelectionne);
        
        var indexAlea = jsonAleaFind.indexAlea;
        var jsonEquipe = null;
       
        if (nbEquipe==0) {
           
            return null;
        }
            
       
        var indexEquipe = jsonAleaFind.indexEquipe;
        
        var equipe = this.parties[indexPartie].equipes[indexEquipe];
        var find = false;
        var keysArray = ["joueurs", "contre"];
        
        while (keysArray.length>0) {
            var indiceKey = Math.floor(Math.random() * Math.floor(keysArray.length));
            var key = keysArray[indiceKey];
            if (!find) {
                var arrayJoueurs = ["J1", "J2", "J3"];
                var indiceJoueur = 0;
                var forcageIndice = typeof(forcage)=="undefined" ? 0 : 1;
                while (arrayJoueurs.length>0 && indiceJoueur!=-1 && !find && forcage!=5) {
                   
                    indiceJoueur = this.findAleaJoueursAllPlay(arrayJoueurs, joueurItem, nbTripletteJoueur, forcage);
                    
                    if (indiceJoueur !=-1) {
                   
                        var joueur = arrayJoueurs[indiceJoueur];
                        if (!find) {
                        
                            var verif = this.verifEquipeAllPlay(joueurItem, joueur, key, equipe, indexPartie, nbTripletteJoueur, forcageIndice);
                        
                            if (verif) {

                                if (equipe.dataJoueurs[key][joueur] == null) {
                                    
                                    if (key =="joueurs") {
                                        if ((Joueur.validCONTRE(joueurItem, equipe.dataJoueurs.contre, forcage)
                                            || forcage >= 3) && (
                                            Joueur.validAMI(joueurItem, equipe.dataJoueurs.joueurs, forcage)
                                            || forcage >=2)
                                            )
                                        {
                                            jsonEquipe={
                                                indexEquipe: indexEquipe,
                                                key: key,
                                                joueur: joueur,
                                                indexAlea: indexAlea
                                            }
                                            find = true;
                                        }
                                    }
                                    else {
                                        if ((Joueur.validCONTRE(joueurItem, equipe.dataJoueurs.joueurs, forcage)
                                            || forcage >= 3) && (
                                            Joueur.validAMI(joueurItem, equipe.dataJoueurs.contre, forcage)
                                            || forcage >=2)
                                            )
                                        {
                                            jsonEquipe={
                                                indexEquipe: indexEquipe,
                                                key: key,
                                                joueur: joueur,
                                                indexAlea: indexAlea
                                            }
                                            find = true;
                                        }
                                    }
                                }
                            }
                            if (!find) {
                                arrayJoueurs.splice(indiceJoueur, 1);
                                if (arrayJoueurs.length==0 && forcageIndice!=4) {
                                    var arrayJoueurs = ["J1", "J2", "J3"];
                                    forcageIndice = 4;
                                } 
                            }
                        }
                    }
                }
            }
            keysArray.splice(indiceKey, 1);
        }
    
        if (jsonEquipe==null) {
            var arrayContruct = JSON.parse(JSON.stringify(arrayIndexEquipesParam));
            arrayContruct[nbGagnePartiePrec].splice(indexAlea, 1);
            
            return this.findEquipeGGAllPlay(indexPartie, joueurItem, arrayContruct, nbGagnePartiePrec, forcage, nbTriplette, nbTripletteJoueur, joueursResteASelectionne);
        }
        else
            return jsonEquipe;
    }
    findAleaEquipeGGAllPlay(indexPartie, joueurItem, arrayIndexEquipesParam, nbGagnePartiePrec, joueursBlanc, joueursResteASelectionne) {
        // je regarde le nombre de jeu à blanc  (dans les jeux qui restent)
       
        var nbEquipe = arrayIndexEquipesParam[nbGagnePartiePrec].length;
        var indexAlea = Math.floor(Math.random() * Math.floor(nbEquipe))
        var jsonReturn = {
            indexAlea : indexAlea,
            indexEquipe: arrayIndexEquipesParam[nbGagnePartiePrec][indexAlea]
        }
    
       
        return jsonReturn;
    }
    aDejaJouerEntriplette(joueurItem, joueur, nbTripletteJoueur, forcage) {
        if (forcage == 4)
            return true;
        if (joueur == "J3" && nbTripletteJoueur.indexOf(joueurItem.numero)!=-1 )
            return false;
        else if (joueur == "J3" && nbTripletteJoueur.indexOf(joueurItem.numero)==-1) {
            return true;    
        }
    }
    verifEquipeAllPlay(joueurItem, joueur, key, equipe, indexPartie, nbTripletteJoueur, forcage) {
        
        var flag = false;
        if (equipe.exists || equipe.exists == null) {
            if (joueur != "J3")
                flag = true
            else if (joueur == "J3" && equipe.triplette!=null) {
                if (this.aDejaJouerEntriplette(joueurItem, joueur, nbTripletteJoueur, forcage) &&  equipe.triplette.state) {
                    if (equipe.triplette.nb == 2)
                        flag = true;
                    else if (equipe.triplette.nb>=0) {
                        if (equipe.triplette.nb == 1)
                            if (equipe.dataJoueurs.contre.J3==null && equipe.dataJoueurs.joueurs.J3==null)
                                flag = true;
                    }
                }
            }
        }
        
        return flag;
    }
}
